"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotingPlanDefinitionList = exports.createQuotingPlanDefinitionList = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
var FORMAT_DATE_OPTIONS = { style: string_formatters_1.DateFormatStyle.STANDARD, timezone: (0, string_formatters_1.getLocalTimezone)() };
function createQuotingPlanDefinitionList(quotingPlan) {
    var clientHref = quotingPlan.clientHref, clientName = quotingPlan.clientName, dueDate = quotingPlan.dueDate;
    var items = [
        {
            type: 'name',
            title: 'Account',
            value: clientName,
            href: clientHref,
        },
        {
            type: 'date',
            title: 'Proposal due date',
            value: "".concat((0, string_formatters_1.formatDate)(dueDate, FORMAT_DATE_OPTIONS)),
        },
    ];
    return items;
}
exports.createQuotingPlanDefinitionList = createQuotingPlanDefinitionList;
function QuotingPlanDefinitionList(props) {
    var quotingPlanDefinition = props.quotingPlanDefinition, hideTitle = props.hideTitle;
    return (react_1.default.createElement(definition_list_1.DefinitionList, { hideTitle: hideTitle, items: createQuotingPlanDefinitionList(quotingPlanDefinition), labelWidth: "150px" }));
}
exports.QuotingPlanDefinitionList = QuotingPlanDefinitionList;
//# sourceMappingURL=index.js.map